const BASE_CND = 'https://s1.pclncdn.com';
const IMPLEMENTATION_ENDPOINTS = {
    DRIVE: '/genai-svc/genai/chat/st/rcListings',
    STAYDETAILS: '/genai-svc/genai/chat/st/hotelDetail',
    STAYLISTINGS: '/genai-svc/genai/chat/st/hotelListings',
    FLYDETAILS: '/genai-svc/genai/chat/st/flightDetail',
    FLYLISTINGS: '/genai-svc/genai/chat/st/flightListings',
    PACKAGE: '/genai-svc/genai/chat/st/package',
    ITINERARY: '/genai-svc/genai/chat/st/travelItinerary',
    LANDING: '/genai-svc/genai/chat/st/homePageSearch',
    CHECKOUT: '/genai-svc/genai/chat/st/checkout',
    PORTAL: '/genai-svc/genai/chat/pennyPortal'
};
export { BASE_CND, IMPLEMENTATION_ENDPOINTS };
